import { jsx as _jsx } from "react/jsx-runtime";
import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { useTranslation } from 'react-i18next';
import { Stat } from 'src/modules/contentList/components/pageCard/stat';
import { DateHelper } from 'src/shared/helpers/date';
export function LiberationStat({ drippingConfig }) {
    const { t } = useTranslation();
    switch (drippingConfig?.liberation?.type) {
        case 'BY_DATE': {
            const formattedDate = DateHelper.formatIsoString(drippingConfig.liberation.liberationDate, {
                dateStyle: 'short'
            });
            return (_jsx(Stat, { icon: faCalendarCheck, value: formattedDate, label: t('content_list.page_card.liberation_by_date', { date: formattedDate }) }));
        }
        case 'BY_DAYS':
            return (_jsx(Stat, { icon: faCalendarCheck, value: t('content_list.page_card.days', {
                    count: drippingConfig.liberation.liberationDays
                }), label: t('content_list.page_card.liberation_by_days', {
                    count: drippingConfig.liberation.liberationDays
                }) }));
        case 'BY_QUIZ':
            return (_jsx(Stat, { icon: faCalendarCheck, value: t('content_list.page_card.quiz_approval'), label: t('content_list.page_card.liberation_by_quiz') }));
        default:
            return null;
    }
}
